import moment from 'moment'

moment.locale(I18n.locale.split('-')[0])
